// Use relative path for both local (via dev server proxy) and production (via api.php proxy)
const API_BASE = "";

export default API_BASE;
